import { render, staticRenderFns } from "./TreeReport.vue?vue&type=template&id=b2abf7ca&scoped=true&"
import script from "./TreeReport.vue?vue&type=script&lang=js&"
export * from "./TreeReport.vue?vue&type=script&lang=js&"
import style0 from "./TreeReport.vue?vue&type=style&index=0&id=b2abf7ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2abf7ca",
  null
  
)

export default component.exports